var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMapMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 21.333,
    viewBox: "0 0 16 21.333",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 21.333,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_map-marker",
    "data-name": "Icon - map-marker",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "map-marker",
    d: "M8,0A8,8,0,0,0,0,8c0,3.226,1.124,4.126,7.178,12.9a1,1,0,0,0,1.644,0C14.876,12.126,16,11.226,16,8A8,8,0,0,0,8,0ZM8,19.747C2.2,11.354,1.333,10.687,1.333,8A6.667,6.667,0,0,1,12.714,3.286,6.623,6.623,0,0,1,14.667,8C14.667,10.687,13.8,11.353,8,19.747Z",
    fill: "#1976d2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMapMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-marker.67b05ee0b2a6ca1bd16019d34998f019.svg";